import * as Types from 'src/actions/user/requiredProfile/Types';
import {
  CheckRequiredProfileAction,

} from 'src/actions/user/requiredProfile/CheckRequiredProfile.actions';

export interface CheckRequiredProfileState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

export const initialCheckRequiredProfileState: CheckRequiredProfileState = {
  loading: false,
  error: false,
  errorMessage: {},
};

export function CheckRequiredProfileReducer(
  state: CheckRequiredProfileState = initialCheckRequiredProfileState,
  action: CheckRequiredProfileAction
): CheckRequiredProfileState {
  switch (action.type) {
    case Types.CHECK_REQUIRED_PROFILE_ATTEMPT:
      return {...state, error: false};
    case Types.CHECK_REQUIRED_PROFILE_SUCCESS:
      return {...state, error: false};
    case Types.CHECK_REQUIRED_PROFILE_FAILURE:
      return {...state, error: true, errorMessage: action.payload};
    case Types.CHECK_REQUIRED_PROFILE_CLEAR:
      return {...state, error: false, errorMessage: {} };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user/CheckRequiredProfile.reducer.tsx